export class Refund {
    balance_after_refund: number = 0;
    refund_allowed: boolean = false;
    error_message: string | null = null;
    refund_amount: number =0;
 
}